import type { ReactNode } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import theme from '../theme';

const MainLayoutDiv = styled.div<{ bg?: string }>`
  width: 100%;
`;

type MainLayoutProps = { children: ReactNode; bg?: string };

const MainLayout = ({ children, bg }: MainLayoutProps) => (
  <MainLayoutDiv bg={bg}>
    <ThemeProvider theme={theme}>
      <div>
        { children }
      </div>
    </ThemeProvider>
  </MainLayoutDiv>
);

export default MainLayout;
